import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getSingleArticle } from '@dealstack/frontend/app/services/Blog.service.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import type { ClientPerspective } from '@sanity/client';

export const useSingleArticle = (
	dataset: ApplicationType,
	slug: string | undefined,
	perspective?: ClientPerspective
) => {
	const request = useQuery({
		queryKey: [
			API_PATHS.HELP_BLOG_DATASET_ARTICLES_SLUG_GET,
			{ dataset, slug: slug || '', perspective },
		],
		queryFn: () =>
			getSingleArticle(API_PATHS.HELP_BLOG_DATASET_ARTICLES_SLUG_GET, {
				dataset,
				slug: slug || '',
				perspective,
			}),
		enabled: !!slug,
	});

	return {
		article: request.data,
		isFetching: request.isFetching,
		error: request.error,
	};
};
